import { render, staticRenderFns } from "./SwitchCol.vue?vue&type=template&id=50af4eba"
import script from "./SwitchCol.vue?vue&type=script&lang=js"
export * from "./SwitchCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports